module.exports = __webpack_public_path__ + "img/kg.28554a61.svg";